import JassEnum from './enum';

/**
 * type attacktype
 */
export default class JassAttackType extends JassEnum {}
